// Customer-facing buying journey — used on Kitchen & Wardrobe category pages.
// Homeowner-friendly: from meeting a dealer to moving in.

const STEPS = [
  {
    n: "01",
    t: "Meet the Dealer",
    d: "Walk into your nearest authorised showroom or franchisee. See finishes, feel the hardware, ask real questions.",
  },
  {
    n: "02",
    t: "Book Your Space",
    d: "Share your floor plan and requirements. The dealer captures your brief and books your project into the production calendar.",
  },
  {
    n: "03",
    t: "Place the Order",
    d: "Approve the design, layout, and finishes. A confirmed order releases the manufacturing schedule.",
  },
  {
    n: "04",
    t: "Installation Begins",
    d: "Modules arrive on-site, factory-finished. A trained installation crew fits everything — usually within 3 days for standard scope.",
  },
  {
    n: "05",
    t: "Move In",
    d: "Final quality walk-through, handover, and warranty pack. You're ready to use the space that same evening.",
  },
];

export const HowItWorks = ({ heading = "How it works", subheading = "From showroom visit to installed space — in five clean steps." }) => {
  return (
    <section data-testid="how-it-works" className="bg-cream py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20 reveal">
          <div>
            <div className="overline mb-4">The buying journey</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-light">
              {heading.split(" ").slice(0, -1).join(" ")}{" "}
              <span className="italic text-teal">{heading.split(" ").slice(-1)}.</span>
            </h2>
          </div>
          <p className="md:text-right md:max-w-sm text-black/60">{subheading}</p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4 lg:gap-0">
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              data-testid={`hiw-step-${s.n}`}
              className="reveal relative bg-ivory p-6 md:p-7 lg:border-r lg:last:border-r-0 border-brandgray"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="flex items-baseline gap-3">
                <span className="font-display text-5xl md:text-6xl text-coral leading-none">{s.n}</span>
                <span className="hidden lg:inline-block flex-1 h-px bg-brandgray translate-y-[-8px]" />
              </div>
              <div className="font-display text-xl md:text-2xl mt-5 leading-snug">{s.t}</div>
              <p className="mt-3 text-sm md:text-base text-black/70 leading-relaxed">{s.d}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
